import { BoardPurchaseUpdatableInterface } from '../interfaces/board-purchase-updatable.interface';
import { BoardPurchaseDto } from './board-purchase.dto';
import { PartialType, PickType } from '@nestjs/swagger';

export class BoardPurchaseUpdateDto
  extends PartialType(
    PickType(BoardPurchaseDto, [
      'approved',
      'approvedGeo',
      'notesForSupplier',
      'invoiceNumber',
      'canceled',
      'datePromised',
      'dateDelivery',
      'cancelNotification',
      'stoppedFulfillment',
      'stoppedFulfillmentNotification',
      'dateExpected',
    ]),
  )
  implements BoardPurchaseUpdatableInterface {}
